module.exports = __webpack_public_path__ + "img/visa.a96b142c.png";